import React, { useState } from 'react';
import styled from 'styled-components';
import AnimateHeight from 'react-animate-height';

const EsApplyAccoItemBlock = styled.div`
    .aa_title_info : 
`;

const EsApplyAccoSubBlock = styled.span`
    display: ${props => props.display || 'none'};
    margin-left: 15px;
    font-size: 12px;
    font-weight: 400;
`;

const EsApplyAccoBrandBlock = styled.span`
    display: ${props => props.display || 'none'};
`;

const EsApplyAccoItemFirstBlock = styled.div`border-top: 2px solid #111;`;

function isFirstItem(isFirst) {
    if (isFirst) {
        return (<EsApplyAccoItemFirstBlock />);
    }
}

/**
 * 견적 신청하기에 아코디언 메뉴 컴포넌트 
 * @param {*} param0 
 */
const EsApplyAccoItem = ({ titleinfo, active, expand, setExpand, isFirst, listComponent }) => {

    // console.log("EsApplyAccoItem ++++++")
    function handleTitleClick(e) {
        setExpand(!expand, titleinfo.id);
    }

    return (
        <EsApplyAccoItemBlock>
            {isFirstItem(isFirst)}
            <li id={titleinfo.id} className={"acco-item" + (active ? ' active' : ' ')} >
                <div className={"acco-title" + (expand ? ' active' : ' ')} onClick={handleTitleClick}>
                    <h3 className="aa-title">
                        <span className="font-mont">{titleinfo.no} </span>
                        {titleinfo.title}
                        <EsApplyAccoBrandBlock display={titleinfo.brand === null ? 'none' : 'inline-block'}> {'[' + titleinfo.brand + ']'} </EsApplyAccoBrandBlock>
                        <EsApplyAccoSubBlock display={expand ? 'inline-block' : 'none'}>{titleinfo.subtitle}</EsApplyAccoSubBlock>
                    </h3>
                    <button type="button" className="acco-btn"></button>
                </div>

                <AnimateHeight duration={200} height={(expand ? 'auto' : 0)}>
                    {listComponent}
                </AnimateHeight>
            </li>
        </EsApplyAccoItemBlock>
    );
};

export default EsApplyAccoItem;